import axios from 'axios';
import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';
import InputField from '../../../../components/InputField';
import axiosInstance from '../../../../services/AxiosInstance';

const CandidateApplications = ({ id }) => {

    let cancelToken;

    const [data, setData] = useState([]);
    const [candidates, setCandidates] = useState([]);

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = (page = 1) => {
        axiosInstance(`can-applyjob/?job=${id}&status=a&page=${page}`)
            .then(res => {
                setData(res.data);
                let candidates = res.data.results;
                setCandidates(
                    candidates.map(candidate => {
                        return {
                            ...candidate,
                            select: false
                        }
                    })
                );
            })
    }

    const handleSearchChange = async e => {
        // Function to cancel previous request on searching for api optimization
        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios.CancelToken.source()
        try {
            await axiosInstance(
                `can-applyjob/?job=${id}&status=a&search=${e.target.value}`,
                {
                    method: "GET",
                    cancelToken: cancelToken.token
                }).then(res => {
                    setData(res.data);
                    let candidates = res.data.results;
                    setCandidates(
                        candidates.map(candidate => {
                            return {
                                ...candidate,
                                select: false
                            }
                        })
                    );
                })
        } finally {
            return data
        }
    }

    const handleApprove = () => {
        axiosInstance('can-applyjob/bulk-approve/', { method: "POST", data: { profiles: candidates.filter(can => can.select).map(can => can.id), job_id: id } })
            .then(res => {
                if (res.status === 200) {
                    swal("", "Approved Successfully", "success", { button: "Ok!", })
                    getData();
                }
            }).catch(err => {
                swal("", err.response.data.detail, "error", { button: "Ok!", })
                console.log('err : ', err?.response);
            })

    }

    return (
        <div className="table-resposive template-table">
            {
                candidates.filter(d => d.select).length > 0 &&
                <button
                    className="site-button btn-sm btn-success"
                    onClick={handleApprove}
                    title="Click here to approve the selected candidates"
                >
                    Approve
                </button>
            }
            <InputField
                className="small-input w-25 float-right"
                placeholder='Search...'
                onChange={handleSearchChange}
            />
            <table className="table-job-bx cv-manager company-manage-job">
                <thead>
                    <tr>
                        <th className="feature">
                            <input
                                type="checkbox"
                                onChange={(e) => {
                                    let checked = e.target.checked;
                                    setCandidates(candidates.map(d => {
                                        d.select = checked;
                                        return d;
                                    }))
                                }}
                                checked={candidates.length > 0 && candidates.every(d => d.select)}
                            />
                        </th>
                        <th>Name</th>
                        <th>Applied On</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        candidates?.length > 0 ? candidates?.map((d, i) => {
                            return (
                                <tr key={i}>
                                    <td className="feature">
                                        <input
                                            type="checkbox"
                                            checked={candidates[i].select}
                                            onChange={(e) => {
                                                candidates[i].select = e.target.checked;
                                                setCandidates([...candidates])
                                            }}
                                        />
                                    </td>
                                    <td className="job-name">{d?.name}</td>
                                    <td>{d?.created_on}</td>
                                    <td>{d?.status}</td>
                                </tr>
                            )
                        })
                            :
                            <tr>
                                <td colSpan="4" className="text-center">No data found</td>
                            </tr>
                    }
                </tbody>
            </table>
        </div>
    );
};

export default CandidateApplications;